import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
 import { DatepickerModule } from 'ngx-bootstrap';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule, Routes } from '@angular/router';
import { APP_BASE_HREF } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { FullLayoutComponent } from './full-layout/full-layout.component';
import { SimpleLayoutComponent } from './simple-layout/simple-layout.component';
import { MenuComponent } from './menu/menu.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';

import { DataTablesModule } from 'angular-datatables';

import { CookieService } from 'ngx-cookie-service';
import { MyDatePickerModule } from 'mydatepicker';


import { NgxDropzoneModule } from 'ngx-dropzone';



@NgModule({
  declarations: [
    AppComponent,
    FullLayoutComponent,
    SimpleLayoutComponent,  
    MenuComponent
  ],
  imports: [
    BrowserModule, BrowserAnimationsModule, AppRoutingModule, FormsModule, HttpModule,
    DatepickerModule.forRoot(),NgbModule.forRoot(),DatePickerModule,DataTablesModule,MyDatePickerModule ,NgxDropzoneModule ],
  providers: [{provide: APP_BASE_HREF, useValue : '/'}, CookieService ],
  bootstrap: [AppComponent]
})
export class AppModule { }
